(function () {
  const AX = (window.RB.AnimKit = window.RB.AnimKit || {});
  const { setText, EASE, Anim, dropPlaceholder, collapsePlaceholder, logFx, play, later, wall, anchorEl, anchorRect, pileOf, centerOf, clamp, fitsCard, tf, peelPile, bumpPile, tickPlate } = AX;
  const { overlay, mkBanner, buildCard, sheenFrames, runArc, runHoldArc, runSpawn, runMorph, domainColor, runShuffle, runRevealFan, runHandFlip, hiddenSelector, arriveExtra, viewportCenter, dockHeld } = AX;

  function mkDim(dur, inAt, outAt) {
    const dim = overlay("fxdim", dur + 40);
    play(dim, [
      { opacity: 0 },
      { opacity: 1, offset: inAt },
      { opacity: 1, offset: outAt },
      { opacity: 0 },
    ], { duration: dur, fill: "forwards" });
    return dim;
  }

  function mkPlate(text, sub, dur, delay, color, top) {
    const p = overlay("fxplate", delay + dur + 40, function (p) {
      if (top) p.style.top = Math.round(clamp(top, 60, window.innerHeight - 70)) + "px";
      if (color) p.style.borderColor = color;
      const t = document.createElement("div");
      t.className = "fxplate-t";
      setText(t, text);
      p.appendChild(t);
      if (sub) {
        const s = document.createElement("div");
        s.className = "fxplate-s";
        setText(s, sub);
        p.appendChild(s);
      }
    });
    play(p, [
      { opacity: 0, clipPath: "inset(0 100% 0 0)", transform: "translate(-50%, 8px)" },
      { opacity: 1, clipPath: "inset(0 0 0 0)", transform: "translate(-50%, 0)", offset: 0.18 },
      { opacity: 1, clipPath: "inset(0 0 0 0)", transform: "translate(-50%, 0)", offset: 0.8 },
      { opacity: 0, clipPath: "inset(0 0 0 100%)", transform: "translate(-50%, 0)" },
    ], { duration: dur, delay: delay, easing: EASE.arc, fill: "both" });
  }

  function mkSheen(box, dur, delay) {
    const clip = document.createElement("div");
    clip.className = "fxsheenclip";
    const sh = document.createElement("div");
    sh.className = "fxsheen";
    clip.appendChild(sh);
    box.appendChild(clip);
    play(sh, sheenFrames(), { duration: dur, delay: delay, easing: EASE.arc, fill: "both" });
  }

  function mkLinkBadge(box, n, color, dur, delay) {
    const b = document.createElement("div");
    b.className = "fxlink";
    b.style.borderColor = color;
    setText(b, String(n));
    box.appendChild(b);
    play(b, [
      { opacity: 0, transform: "scale(.2) rotate(-26deg)" },
      { opacity: 1, transform: "scale(1.3) rotate(5deg)", offset: 0.12 },
      { opacity: 1, transform: "scale(1) rotate(0deg)", offset: 0.26 },
      { opacity: 1, transform: "scale(1) rotate(0deg)", offset: 0.82 },
      { opacity: 0, transform: "scale(.66) rotate(0deg)" },
    ], { duration: dur, delay: delay, easing: EASE.settle, fill: "both" });
  }

  function runChain(s, dur) {
    dockHeld();
    const from = anchorRect(s.from);
    if (!from) { if (s.text) mkBanner(s.text, false, dur, "gold"); return; }
    const src = fitsCard(from) ? from : null;
    const w0 = src ? src.width : 62;
    const h0 = src ? src.height : 86;
    const h = Math.max(120, Math.min(200, Math.round(h0 * 1.76)));
    const w = Math.max(40, Math.round(h * (w0 / h0)));
    const k0 = h0 / h;
    const a = centerOf(from);
    const color = domainColor(s.domain);
    const px = clamp(a.x, w / 2 + 14, window.innerWidth - w / 2 - 14) - a.x;
    const py = clamp(a.y, h / 2 + 14, window.innerHeight - h / 2 - 14) - a.y - 10;

    s.artW = w;
    const built = buildCard(s, w, h);
    const box = built.box;
    box.classList.add("chainfly");
    box.style.left = (a.x - w / 2) + "px";
    box.style.top = (a.y - h / 2) + "px";
    Anim.layer().appendChild(box);

    if (Anim.flat()) {
      play(box, [{ opacity: 0 }, { opacity: 1, offset: 0.3 }, { opacity: 0 }], { duration: dur, easing: "linear", fill: "forwards" });
      later(function () { box.remove(); }, dur + 40);
      return;
    }

    const rise = 0.22;
    const fall = s.hold ? 0.78 : 0.72;
    const at = function (f) { return Math.max(0, Math.round(dur * f)); };
    const cy = a.y + py;

    mkDim(dur, rise * 0.6, Math.min(0.95, fall + 0.08));
    mkSheen(box, at(0.32), at(rise + 0.04));
    if (s.link) mkLinkBadge(box, s.link, color, at(fall + 0.06 - rise), at(rise));
    if (s.text) mkPlate(s.text, s.sub, at(fall + 0.02 - rise), at(rise + 0.03), color, cy + h / 2 + 18);

    const flash = document.createElement("div");
    flash.className = "fxrimflash";
    box.appendChild(flash);
    play(flash, [
      { opacity: 0 },
      { opacity: .55, offset: 0.24 },
      { opacity: 0 },
    ], { duration: at(0.24), delay: at(rise - 0.04), fill: "both" });

    play(box, [
      { opacity: 1, transform: tf(0, 0, 0, k0), easing: EASE.peel },
      { transform: tf(px * 0.58, py * 0.58, 0, k0 + (1 - k0) * 0.64), offset: 0.1, easing: EASE.arc },
      { transform: tf(px, py, 0, 1), offset: rise, easing: "linear" },
      { transform: tf(px, py, 0, 1), offset: fall, easing: EASE.arc },
      { opacity: 1, transform: tf(px * 0.34, py * 0.34, 0, k0 + (1 - k0) * 0.36), offset: fall + (1 - fall) * 0.62 },
      { opacity: 0, transform: tf(0, 0, 0, k0) },
    ], { duration: dur, fill: "forwards" });

    tickPlate(anchorEl(s.to), at(0.9), "fxtick-good");
    later(function () { box.remove(); }, dur + 24);
  }

  function runResolve(s, dur) {
    const from = anchorRect(s.from);
    const c = viewportCenter();
    const w = 86, h = 120;
    const big = 1.15;
    const color = domainColor(s.domain);
    const built = buildCard(s, w, h);
    const box = built.box;
    box.classList.add("chainfly");
    box.style.left = (c.x - w / 2) + "px";
    box.style.top = (c.y - h / 2) + "px";
    Anim.layer().appendChild(box);
    if (Anim._held) { try { Anim._held.remove(); } catch (e) { } }
    Anim._held = box;

    if (Anim.flat() || !from) {
      play(box, [{ opacity: 0 }, { opacity: 1, offset: 0.2 }, { opacity: 1 }], { duration: dur, fill: "forwards" });
      mkPlate(s.text, s.sub, Math.round(dur * 0.8), Math.round(dur * 0.1), color);
      return;
    }
    const a = centerOf(from);
    const k0 = fitsCard(from) ? Math.max(0.2, Math.min(1.2, from.width / w)) : 0.4;
    const dx = a.x - c.x, dy = a.y - c.y;
    box._dim = mkDim(dur * 1.1, 0.12, 0.8);
    play(box, [
      { opacity: 1, transform: tf(dx, dy, 0, k0), easing: EASE.arc },
      { transform: tf(dx * 0.4, dy * 0.4 - 30, -3, (k0 + big) / 2), offset: 0.3, easing: EASE.apex },
      { transform: tf(0, 0, 0, big), offset: 0.55, easing: EASE.settle },
      { opacity: 1, transform: tf(0, 0, 0, big) },
    ], { duration: dur, fill: "forwards" });
    mkPlate(s.text, s.sub, Math.round(dur * 0.7), Math.round(dur * 0.42), color);
    const gen = Anim._gen;
    later(function () {
      if (Anim._gen !== gen || Anim._held !== box) return;
      Anim._held = null;
      play(box, [{ opacity: 1 }, { opacity: 0 }], { duration: 90, fill: "forwards" });
      later(function () { box.remove(); }, 120);
    }, dur * 2);
  }

  function runRetire(s, dur) {
    const to = anchorRect(s.to);
    const c = viewportCenter();
    let box = Anim._held;
    Anim._held = null;
    const w = 86, h = 120;
    if (!box) {
      box = buildCard(s, w, h).box;
      box.classList.add("chainfly");
      box.style.left = (c.x - w / 2) + "px";
      box.style.top = (c.y - h / 2) + "px";
      Anim.layer().appendChild(box);
    }
    if (!to) {
      play(box, [{ opacity: 1 }, { opacity: 0 }], { duration: dur, fill: "forwards" });
      later(function () { box.remove(); }, dur + 20);
      return;
    }
    const b = centerOf(to);
    const dx = b.x - c.x, dy = b.y - c.y;
    const kEnd = fitsCard(to) ? Math.max(0.25, Math.min(1.2, to.width / w)) : 0.5;
    const d = box._docked;
    const restTf = d ? tf(d.dx, d.dy, 0, d.k) : tf(0, 0, 0, 1.15);
    play(box, [
      { transform: restTf, filter: "none", easing: EASE.arc },
      { transform: restTf, filter: "grayscale(.85) brightness(.72)", offset: 0.3, easing: EASE.fall },
      { transform: tf(dx, dy, 15, kEnd), filter: "grayscale(1) brightness(.6)" },
    ], { duration: dur, fill: "forwards" });
    const dstPile = pileOf(s.to);
    if (dstPile) bumpPile(dstPile, Math.round(dur * 0.94));
    tickPlate(anchorEl(s.to), Math.round(dur * 0.92), "fxtick-bad");
    later(function () { box.remove(); }, dur + 24);
  }

  const BLAST_AT = 0.34;
  const BLAST_FRAGS = [
    { clip: "polygon(50% 44%, 0 0, 46% 0)", dx: -74, dy: -46, rot: -120 },
    { clip: "polygon(50% 44%, 46% 0, 100% 0)", dx: 18, dy: -78, rot: 96 },
    { clip: "polygon(50% 44%, 100% 0, 100% 42%)", dx: 88, dy: -34, rot: 140 },
    { clip: "polygon(50% 44%, 100% 42%, 100% 100%)", dx: 96, dy: 40, rot: 74 },
    { clip: "polygon(50% 44%, 100% 100%, 50% 100%)", dx: 26, dy: 84, rot: -64 },
    { clip: "polygon(50% 44%, 50% 100%, 0 100%)", dx: -40, dy: 90, rot: 108 },
    { clip: "polygon(50% 44%, 0 100%, 0 46%)", dx: -98, dy: 26, rot: -96 },
    { clip: "polygon(50% 44%, 0 46%, 0 0)", dx: -92, dy: -20, rot: -150 },
  ];
  const BLAST_SEAMS = [
    { x: 8, y: 12, w: 46, rot: -24 },
    { x: 12, y: 46, w: 42, rot: 18 },
    { x: 4, y: 68, w: 50, rot: -8 },
  ];
  const BLAST_REACH = 3.4;
  const BLAST_SETTLE = 0.7;
  const BLAST_EDGE = 8;

  function corpseCard(s, r) {
    const slot = Anim._prevSlot[s.from && s.from.prevOf];
    let e;
    if (slot && slot.clone && slot.clone.cloneNode) {
      e = slot.clone.cloneNode(true);
      e.removeAttribute("data-iid");
      e.removeAttribute("data-fxkey");
      e.removeAttribute("data-anchor");
      e.style.width = r.width + "px";
      e.style.height = r.height + "px";
    } else {
      e = buildCard(s, r.width, r.height).box;
    }
    e.classList.add("fxcorpse");
    e.style.left = r.left + "px";
    e.style.top = r.top + "px";
    return e;
  }

  function blastNeighbours(host, r, c, reach) {
    const out = [];
    if (!host || !host.querySelectorAll) return out;
    const all = host.querySelectorAll("[data-iid]");
    for (let i = 0; i < all.length; i++) {
      const e = all[i];
      if (!e.getBoundingClientRect) continue;
      const b = e.getBoundingClientRect();
      if (!fitsCard(b) || b.top > r.bottom || b.bottom < r.top) continue;
      const dx = b.left + b.width / 2 - c.x;
      if (!dx || Math.abs(dx) > reach) continue;
      out.push({ el: e, dir: dx > 0 ? 1 : -1, near: 1 - Math.abs(dx) / reach });
    }
    return out;
  }

  function runDetonate(s, dur) {
    const r = anchorRect(s.from) || anchorRect(s.at);
    const pile = pileOf(s.to);
    const host = anchorEl(s.to);
    const burst = Math.round(dur * BLAST_AT);
    if (!r || !fitsCard(r) || Anim.flat()) {
      if (s.fallbackText) mkBanner(s.fallbackText, false, dur, "red");
      if (pile) bumpPile(pile, Math.min(burst, dur));
      tickPlate(host, Math.min(burst, dur), "fxtick-bad");
      return;
    }
    const l = Anim.layer();
    const c = centerOf(r);
    const sc = r.width / 64;
    const after = dur - burst;
    const trash = [];
    const keep = function (e) { trash.push(e); l.appendChild(e); return e; };
    later(function () { for (const e of trash) { try { e.remove(); } catch (x) { } } }, Math.round(dur * 1.5) + 80);

    const body = keep(corpseCard(s, r));
    play(body, [
      { opacity: 1, transform: "scale(1)", filter: "none", easing: EASE.apex },
      { opacity: 1, transform: "scale(1.06)", filter: "brightness(2.4) saturate(.7)", offset: BLAST_AT - 0.07 },
      { opacity: 1, transform: "scale(1.15)", filter: "brightness(5.5) saturate(.15)", offset: BLAST_AT - 0.01 },
      { opacity: 0, transform: "scale(1.32)", filter: "brightness(6) saturate(0)", offset: BLAST_AT + 0.01 },
      { opacity: 0, transform: "scale(1.32)", filter: "brightness(6) saturate(0)" },
    ], { duration: dur, fill: "both" });

    for (const sm of BLAST_SEAMS) {
      const e = keep(document.createElement("div"));
      e.className = "fxseam";
      e.style.left = (r.left + sm.x * sc) + "px";
      e.style.top = (r.top + sm.y * sc) + "px";
      e.style.width = Math.round(sm.w * sc) + "px";
      const rot = "rotate(" + sm.rot + "deg) ";
      play(e, [
        { opacity: 0, transform: rot + "scaleX(0)" },
        { opacity: 0, transform: rot + "scaleX(0)", offset: BLAST_AT - 0.14 },
        { opacity: .95, transform: rot + "scaleX(1)", offset: BLAST_AT - 0.05 },
        { opacity: 0, transform: rot + "scaleX(1)", offset: BLAST_AT },
        { opacity: 0, transform: rot + "scaleX(1)" },
      ], { duration: dur, fill: "both" });
    }

    const flash = keep(document.createElement("div"));
    flash.className = "fxburst";
    flash.style.left = c.x + "px";
    flash.style.top = c.y + "px";
    flash.style.width = Math.round(r.width * 4.6) + "px";
    flash.style.height = Math.round(r.width * 4.6) + "px";
    play(flash, [
      { opacity: 0, transform: "translate(-50%,-50%) scale(.4)" },
      { opacity: .92, transform: "translate(-50%,-50%) scale(1)", offset: 0.12 },
      { opacity: 0, transform: "translate(-50%,-50%) scale(1.3)" },
    ], { duration: Math.round(after * 0.62), delay: burst, easing: EASE.fall, fill: "both" });

    const ring = keep(document.createElement("div"));
    ring.className = "fxring";
    const rw = Math.round(r.width * 1.5);
    ring.style.left = (c.x - rw / 2) + "px";
    ring.style.top = (c.y - rw / 2) + "px";
    ring.style.width = rw + "px";
    ring.style.height = rw + "px";
    ring.style.borderRadius = "50%";
    ring.style.borderColor = "#ffd7a1";
    ring.style.boxShadow = "0 0 30px rgba(255, 180, 110, .8)";
    play(ring, [
      { opacity: 0, transform: "scale(.14)", borderWidth: "5px" },
      { opacity: 1, transform: "scale(.6)", borderWidth: "5px", offset: 0.14 },
      { opacity: 0, transform: "scale(3.5)", borderWidth: "0px" },
    ], { duration: Math.round(dur * 0.55), delay: burst, easing: EASE.arc, fill: "both" });

    const dim = keep(document.createElement("div"));
    dim.className = "fxdim";
    play(dim, [
      { opacity: 0 }, { opacity: .62, offset: 0.14 }, { opacity: .5, offset: 0.4 }, { opacity: 0 },
    ], { duration: Math.round(dur * 0.62), delay: burst, fill: "both" });

    const vw = window.innerWidth, vh = window.innerHeight;
    for (const f of BLAST_FRAGS) {
      const e = keep(corpseCard(s, r));
      e.classList.add("fxfrag");
      e.style.clipPath = f.clip;
      let dx = Math.round(f.dx * sc), dy = Math.round(f.dy * sc);
      if (c.x + dx < BLAST_EDGE || c.x + dx > vw - BLAST_EDGE) dx = -dx;
      if (c.y + dy < BLAST_EDGE || c.y + dy > vh - BLAST_EDGE) dy = -dy;
      const to = "translate(" + dx + "px," + dy + "px) rotate(" + f.rot + "deg) scale(.55)";
      play(e, [
        { opacity: 0, transform: "translate(0,0) rotate(0deg) scale(1)", filter: "brightness(3) sepia(.5)" },
        { opacity: 1, transform: "translate(0,0) rotate(0deg) scale(1)", filter: "brightness(2.4) sepia(.6)", offset: 0.04 },
        { opacity: 0, transform: to, filter: "brightness(.7) sepia(1)" },
      ], { duration: after, delay: burst, easing: "cubic-bezier(.15,.6,.4,1)", fill: "both" });
    }

    const scorch = keep(document.createElement("div"));
    scorch.className = "fxscorch";
    scorch.style.left = c.x + "px";
    scorch.style.top = c.y + "px";
    scorch.style.width = Math.round(r.width * 1.7) + "px";
    scorch.style.height = Math.round(r.height * 0.34) + "px";
    play(scorch, [
      { opacity: 0, transform: "translate(-50%,-50%) scale(.35)" },
      { opacity: .8, transform: "translate(-50%,-50%) scale(1)", offset: 0.06 },
      { opacity: .5, transform: "translate(-50%,-50%) scale(1)", offset: 0.55 },
      { opacity: 0, transform: "translate(-50%,-50%) scale(1.06)" },
    ], { duration: Math.round(dur * 1.3), delay: burst, easing: EASE.fall, fill: "both" });

    const table = document.getElementById("bfarea") || document.querySelector("#arena .arfit") || document.body;
    play(table, [
      { transform: "translate(0,0)" },
      { transform: "translate(-6px,4px)", offset: 0.2 },
      { transform: "translate(6px,-4px)", offset: 0.42 },
      { transform: "translate(-4px,-2px)", offset: 0.64 },
      { transform: "translate(3px,2px)", offset: 0.82 },
      { transform: "translate(0,0)" },
    ], { duration: Math.round(dur * 0.26), delay: burst, easing: "linear" });

    for (const n of blastNeighbours(anchorEl(s.at), r, c, r.width * BLAST_REACH)) {
      const px = Math.round(14 * n.near * n.dir * sc);
      const rot = (6 * n.near * n.dir).toFixed(1);
      play(n.el, [
        { transform: "translateX(0) rotate(0deg)", easing: EASE.fall },
        { transform: "translateX(" + px + "px) rotate(" + rot + "deg)", offset: 0.28, easing: EASE.settle },
        { transform: "translateX(" + Math.round(-px * 0.2) + "px) rotate(0deg)", offset: 0.68 },
        { transform: "translateX(0) rotate(0deg)" },
      ], { duration: Math.round(dur * (BLAST_SETTLE - BLAST_AT)), delay: burst });
    }

    if (pile) bumpPile(pile, burst);
    tickPlate(host, burst, "fxtick-bad");
  }

  function fxBox(cls, r, pad) {
    const e = document.createElement("div");
    e.className = cls;
    e.style.left = (r.left - pad) + "px";
    e.style.top = (r.top - pad) + "px";
    e.style.width = (r.width + pad * 2) + "px";
    e.style.height = (r.height + pad * 2) + "px";
    Anim.layer().appendChild(e);
    return e;
  }

  function runFlourish(s, dur) {
    const el = anchorEl(s.at);
    const r = anchorRect(s.at);
    if (!r || Anim.flat()) return;
    const l = Anim.layer();
    const c = centerOf(r);
    const color = domainColor(s.domain);
    const d = String(s.domain || "").toLowerCase();
    const trash = [];
    const done = function () { for (const e of trash) { try { e.remove(); } catch (x) { } } };
    later(done, dur + 80);

    if (d === "fury") {
      for (let i = 0; i < 2; i++) {
        const sl = document.createElement("div");
        sl.className = "fxslash";
        sl.style.left = (c.x - 62) + "px";
        sl.style.top = (c.y - 2) + "px";
        sl.style.background = "linear-gradient(90deg, " + color + ", #fff 50%, " + color + ")";
        sl.style.boxShadow = "0 0 14px " + color;
        l.appendChild(sl); trash.push(sl);
        const rot = i === 0 ? -56 : 58;
        play(sl, [
          { opacity: 0, transform: "rotate(" + rot + "deg) scaleX(0)" },
          { opacity: 1, transform: "rotate(" + rot + "deg) scaleX(1)", offset: 0.35 },
          { opacity: 0, transform: "rotate(" + rot + "deg) scaleX(1)" },
        ], { duration: Math.round(dur * 0.55), delay: i * 60, easing: EASE.fall, fill: "both" });
      }
      for (let i = 0; i < 4; i++) {
        const em = document.createElement("div");
        em.className = "fxemberdot";
        em.style.left = (c.x - 22 + i * 15) + "px";
        em.style.top = (c.y + 8) + "px";
        em.style.background = color;
        em.style.boxShadow = "0 0 7px " + color;
        l.appendChild(em); trash.push(em);
        play(em, [
          { opacity: 0, transform: "translate(0,0) scale(1)" },
          { opacity: 1, offset: 0.2 },
          { opacity: 0, transform: "translate(" + (i * 14 - 20) + "px, 40px) scale(.35)" },
        ], { duration: Math.round(dur * 0.7), delay: Math.round(dur * 0.3), easing: EASE.fall, fill: "both" });
      }
      if (el) play(el, [{ transform: "scale(1)" }, { transform: "scale(1.06)", offset: 0.4 }, { transform: "scale(1)" }], { duration: Math.round(dur * 0.6), delay: Math.round(dur * 0.2) });
      return;
    }
    if (d === "calm") {
      const wash = fxBox("fxwash", r, 6);
      wash.style.background = "linear-gradient(0deg, transparent, " + color + " 45%, #fff 60%, transparent)";
      trash.push(wash);
      play(wash, [
        { opacity: 0, transform: "translateY(80px)" },
        { opacity: .8, offset: 0.3 },
        { opacity: 0, transform: "translateY(-90px)" },
      ], { duration: dur, easing: EASE.arc, fill: "both" });
      if (el) play(el, [
        { transform: "skewX(0deg) scaleX(1)" },
        { transform: "skewX(-2.6deg) scaleX(1.05)", offset: 0.4 },
        { transform: "skewX(1.7deg) scaleX(.97)", offset: 0.7 },
        { transform: "skewX(0deg) scaleX(1)" },
      ], { duration: dur, easing: EASE.arc });
      return;
    }
    if (d === "mind") {
      const size = Math.max(r.width, r.height) + 24;
      const svgNs = "http://www.w3.org/2000/svg";
      const svg = document.createElementNS(svgNs, "svg");
      svg.setAttribute("viewBox", "0 0 100 100");
      svg.setAttribute("class", "fxglyph");
      svg.style.left = (c.x - size / 2) + "px";
      svg.style.top = (c.y - size / 2) + "px";
      svg.style.width = size + "px";
      svg.style.height = size + "px";
      const circ = document.createElementNS(svgNs, "circle");
      circ.setAttribute("cx", "50"); circ.setAttribute("cy", "50"); circ.setAttribute("r", "44");
      circ.setAttribute("fill", "none"); circ.setAttribute("stroke", color); circ.setAttribute("stroke-width", "1.8");
      circ.setAttribute("stroke-dasharray", "277"); circ.setAttribute("stroke-linecap", "round");
      const ticks = document.createElementNS(svgNs, "path");
      ticks.setAttribute("d", "M50 6 L50 18 M94 50 L82 50 M50 94 L50 82 M6 50 L18 50 M28 28 L72 72 M72 28 L28 72");
      ticks.setAttribute("stroke", color); ticks.setAttribute("stroke-width", "1.4"); ticks.setAttribute("fill", "none"); ticks.setAttribute("stroke-linecap", "round");
      svg.appendChild(circ); svg.appendChild(ticks);
      l.appendChild(svg); trash.push(svg);
      play(svg, [{ transform: "rotate(-30deg)" }, { transform: "rotate(16deg)" }], { duration: dur, easing: EASE.arc, fill: "both" });
      play(circ, [
        { strokeDashoffset: 277, opacity: 0 }, { opacity: 1, offset: 0.12 },
        { strokeDashoffset: 0, opacity: 1, offset: 0.55 }, { strokeDashoffset: 0, opacity: 0 },
      ], { duration: dur, easing: EASE.arc, fill: "both" });
      play(ticks, [{ opacity: 0 }, { opacity: 0, offset: 0.3 }, { opacity: 1, offset: 0.45 }, { opacity: 1, offset: 0.8 }, { opacity: 0 }], { duration: dur, fill: "both" });
      const snap = fxBox("fxsnap", r, 8);
      snap.style.borderColor = "#cfe6ff";
      snap.style.boxShadow = "0 0 22px " + color;
      trash.push(snap);
      play(snap, [
        { opacity: 0, transform: "scale(1.3)" }, { opacity: 0, transform: "scale(1.3)", offset: 0.6 },
        { opacity: 1, transform: "scale(1)", offset: 0.7 }, { opacity: 0, transform: "scale(.84)" },
      ], { duration: dur, easing: EASE.fall, fill: "both" });
      return;
    }
    if (d === "body") {
      const dust = document.createElement("div");
      dust.className = "fxdust";
      dust.style.left = (c.x - 48) + "px";
      dust.style.top = (r.bottom - 12) + "px";
      dust.style.borderColor = color;
      dust.style.boxShadow = "0 0 20px " + color;
      l.appendChild(dust); trash.push(dust);
      play(dust, [
        { opacity: 0, transform: "scale(.3)" }, { opacity: .85, transform: "scale(1)", offset: 0.25 },
        { opacity: 0, transform: "scale(2.2)" },
      ], { duration: dur, delay: Math.round(dur * 0.25), easing: EASE.arc, fill: "both" });
      const rots = [14, -20, 196];
      for (let i = 0; i < 3; i++) {
        const cr = document.createElement("div");
        cr.className = "fxcrack";
        cr.style.left = c.x + "px";
        cr.style.top = (r.bottom + 2) + "px";
        cr.style.background = "linear-gradient(90deg, " + color + ", transparent)";
        cr.style.transform = "rotate(" + rots[i] + "deg)";
        l.appendChild(cr); trash.push(cr);
        play(cr, [
          { opacity: 0, transform: "rotate(" + rots[i] + "deg) scaleX(0)" },
          { opacity: 1, transform: "rotate(" + rots[i] + "deg) scaleX(1)", offset: 0.2 },
          { opacity: 0, transform: "rotate(" + rots[i] + "deg) scaleX(1)" },
        ], { duration: Math.round(dur * 0.75), delay: Math.round(dur * 0.3), easing: EASE.fall, fill: "both" });
      }
      const table = document.getElementById("bfarea") || document.body;
      play(table, [
        { transform: "translate(0,0)" }, { transform: "translate(-4px,3px)", offset: 0.3 },
        { transform: "translate(4px,-2px)", offset: 0.5 }, { transform: "translate(-2px,-2px)", offset: 0.7 },
        { transform: "translate(0,0)" },
      ], { duration: Math.round(dur * 0.45), delay: Math.round(dur * 0.3), easing: "linear" });
      if (s.attackerIid) {
        const atk = document.querySelector("[data-iid='" + s.attackerIid + "']");
        if (atk) play(atk, [
          { transform: "translateY(-14px)" }, { transform: "translateY(0)", offset: 0.5 },
          { transform: "translateY(-4px)", offset: 0.75 }, { transform: "translateY(0)" },
        ], { duration: Math.round(dur * 0.6), easing: EASE.fall });
      }
      return;
    }
    if (d === "chaos") {
      if (!el || !el.cloneNode) return;
      const bands = [[0, 66], [34, 34], [66, 0]];
      const offs = [[-14, 8, -4], [12, -9, 4], [-10, 6, 0]];
      for (let i = 0; i < 3; i++) {
        const cl = el.cloneNode(true);
        cl.className = "fxshard";
        cl.style.left = r.left + "px"; cl.style.top = r.top + "px";
        cl.style.width = r.width + "px"; cl.style.height = r.height + "px";
        cl.style.clipPath = "inset(0 " + bands[i][1] + "% 0 " + bands[i][0] + "%)";
        l.appendChild(cl); trash.push(cl);
        play(cl, [
          { transform: "translateY(0)", opacity: 1 },
          { transform: "translateY(" + offs[i][0] + "px)", offset: 0.25 },
          { transform: "translateY(" + offs[i][1] + "px)", offset: 0.5 },
          { transform: "translateY(" + offs[i][2] + "px)", offset: 0.75 },
          { transform: "translateY(0)", opacity: 1 },
        ], { duration: dur, easing: "steps(1, end)", fill: "both" });
      }
      const ghost = el.cloneNode(true);
      ghost.className = "fxshard fxghost";
      ghost.style.left = r.left + "px"; ghost.style.top = r.top + "px";
      ghost.style.width = r.width + "px"; ghost.style.height = r.height + "px";
      ghost.style.clipPath = "inset(0 66% 0 0)";
      l.appendChild(ghost); trash.push(ghost);
      play(ghost, [
        { opacity: 0, transform: "translateY(0)" }, { opacity: .6, transform: "translateY(-10px)", offset: 0.3 },
        { opacity: .45, transform: "translateY(7px)", offset: 0.6 }, { opacity: 0, transform: "translateY(0)" },
      ], { duration: dur, easing: "steps(1, end)", fill: "both" });
      play(el, [{ opacity: 1 }, { opacity: .12, offset: 0.1 }, { opacity: .12, offset: 0.9 }, { opacity: 1 }], { duration: dur, fill: "both" });
      return;
    }
    if (d === "order") {
      const pillar = document.createElement("div");
      pillar.className = "fxpillar";
      pillar.style.left = (c.x - 24) + "px";
      pillar.style.top = "0px";
      pillar.style.height = c.y + "px";
      pillar.style.background = "linear-gradient(180deg, #fff8c4, " + color + " 45%, transparent)";
      l.appendChild(pillar); trash.push(pillar);
      play(pillar, [
        { opacity: 0, transform: "scaleY(0)" }, { opacity: .9, transform: "scaleY(1)", offset: 0.3 },
        { opacity: .7, transform: "scaleY(1)", offset: 0.6 }, { opacity: 0, transform: "scaleY(1)" },
      ], { duration: dur, easing: EASE.fall, fill: "both" });
      const size = Math.max(r.width, r.height) + 24;
      const svgNs = "http://www.w3.org/2000/svg";
      const svg = document.createElementNS(svgNs, "svg");
      svg.setAttribute("viewBox", "0 0 100 100");
      svg.setAttribute("class", "fxglyph");
      svg.style.left = (c.x - size / 2) + "px";
      svg.style.top = (c.y - size / 2) + "px";
      svg.style.width = size + "px";
      svg.style.height = size + "px";
      svg.innerHTML = "<circle cx='50' cy='50' r='46' fill='none' stroke='" + color + "' stroke-width='2'/>" +
        "<circle cx='50' cy='50' r='37' fill='none' stroke='#fff8c4' stroke-width='1' opacity='.8'/>" +
        "<path d='M50 12 L58 32 L79 33 L63 46 L69 66 L50 55 L31 66 L37 46 L21 33 L42 32 Z' fill='none' stroke='" + color + "' stroke-width='1.4' stroke-linejoin='round' opacity='.9'/>";
      l.appendChild(svg); trash.push(svg);
      play(svg, [
        { opacity: 0, transform: "scale(2.4) rotate(-26deg)" }, { opacity: 0, transform: "scale(2.4) rotate(-26deg)", offset: 0.3 },
        { opacity: 1, transform: "scale(1) rotate(0deg)", offset: 0.5 }, { transform: "scale(1.09) rotate(0deg)", offset: 0.6 },
        { opacity: 1, transform: "scale(1) rotate(0deg)", offset: 0.85 }, { opacity: 0, transform: "scale(1) rotate(0deg)" },
      ], { duration: dur, easing: EASE.fall, fill: "both" });
      const flare = document.createElement("div");
      flare.className = "fxflare";
      flare.style.left = (c.x - 92) + "px";
      flare.style.top = (c.y - 1) + "px";
      flare.style.background = "linear-gradient(90deg, transparent, #fff8c4, transparent)";
      flare.style.boxShadow = "0 0 16px " + color;
      l.appendChild(flare); trash.push(flare);
      play(flare, [
        { opacity: 0, transform: "scaleX(0)" }, { opacity: 0, transform: "scaleX(0)", offset: 0.5 },
        { opacity: 1, transform: "scaleX(1)", offset: 0.6 }, { opacity: 0, transform: "scaleX(1.35)" },
      ], { duration: dur, easing: EASE.arc, fill: "both" });
      return;
    }
    const ring = fxBox("fxring", r, 6);
    trash.push(ring);
    play(ring, [{ opacity: 0, transform: "scale(.8)" }, { opacity: .9, transform: "scale(1)", offset: 0.3 }, { opacity: 0, transform: "scale(1.4)" }], { duration: dur, easing: "ease-out", fill: "both" });
  }

  function runClaim(s, dur) {
    const host = anchorEl(s.at);
    const r = anchorRect(s.at);
    if (!r) { mkBanner(s.word, true, dur, "gold"); return; }
    const l = Anim.layer();
    const c = centerOf(r);
    const tint = s.player === 0 ? "228, 87, 74" : "107, 183, 255";
    const pad = 6;

    if (Anim.flat()) {
      const stamp = document.createElement("div");
      stamp.className = "fxclaimstamp";
      stamp.textContent = s.word;
      stamp.style.left = c.x + "px"; stamp.style.top = c.y + "px";
      l.appendChild(stamp);
      play(stamp, [{ opacity: 0 }, { opacity: 1, offset: 0.2 }, { opacity: 1, offset: 0.8 }, { opacity: 0 }], { duration: dur, fill: "both" });
      later(function () { stamp.remove(); }, dur + 40);
      return;
    }

    const wash = document.createElement("div");
    wash.className = "fxclaimwash";
    wash.style.left = (r.left - pad) + "px"; wash.style.top = (r.top - pad) + "px";
    wash.style.width = (r.width + pad * 2) + "px"; wash.style.height = (r.height + pad * 2) + "px";
    wash.style.background = "linear-gradient(180deg, rgba(" + tint + ", 0) 0%, rgba(" + tint + ", .55) 55%, rgba(" + tint + ", .85) 100%)";
    l.appendChild(wash);
    play(wash, [
      { opacity: 0, clipPath: "inset(100% 0 0 0)", easing: EASE.arc },
      { opacity: 1, clipPath: "inset(0 0 0 0)", offset: 0.3, easing: "ease-out" },
      { opacity: .7, clipPath: "inset(0 0 0 0)", offset: 0.62, easing: "ease-in" },
      { opacity: 0, clipPath: "inset(0 0 0 0)" },
    ], { duration: dur, fill: "both" });
    later(function () { wash.remove(); }, dur + 40);

    if (host) play(host, [
      { transform: "none", filter: "brightness(1)" },
      { transform: "translateY(-3px) scale(1.015)", filter: "brightness(1.35)", offset: 0.32, easing: EASE.settle },
      { transform: "none", filter: "brightness(1)" },
    ], { duration: dur, easing: "ease-out" });

    const ring = document.createElement("div");
    ring.className = "fxring fxclaimring";
    ring.style.left = r.left + "px"; ring.style.top = r.top + "px";
    ring.style.width = r.width + "px"; ring.style.height = r.height + "px";
    ring.style.borderColor = "rgb(" + tint + ")";
    ring.style.boxShadow = "0 0 22px rgba(" + tint + ", .8), inset 0 0 22px rgba(" + tint + ", .5)";
    l.appendChild(ring);
    play(ring, [
      { opacity: 0, transform: "scale(.96)" },
      { opacity: 1, transform: "scale(1)", offset: 0.28, easing: "ease-out" },
      { opacity: 0, transform: "scale(1.16)" },
    ], { duration: Math.round(dur * 0.8), delay: Math.round(dur * 0.22), easing: "ease-out", fill: "both" });
    later(function () { ring.remove(); }, dur + 40);

    const stamp = document.createElement("div");
    stamp.className = "fxclaimstamp";
    stamp.textContent = s.word;
    stamp.style.left = c.x + "px"; stamp.style.top = c.y + "px";
    stamp.style.color = "#fff3d6";
    stamp.style.textShadow = "0 0 18px rgba(" + tint + ", .95), 0 2px 0 rgba(0,0,0,.6)";
    stamp.style.borderColor = "rgba(" + tint + ", .9)";
    l.appendChild(stamp);
    play(stamp, [
      { opacity: 0, transform: "translate(-50%,-50%) scale(2.2) rotate(-6deg)", easing: "cubic-bezier(.2,1.2,.4,1)" },
      { opacity: 1, transform: "translate(-50%,-50%) scale(.94) rotate(-6deg)", offset: 0.3, easing: EASE.settle },
      { opacity: 1, transform: "translate(-50%,-50%) scale(1) rotate(-6deg)", offset: 0.42 },
      { opacity: 1, transform: "translate(-50%,-50%) scale(1) rotate(-6deg)", offset: 0.82, easing: "ease-in" },
      { opacity: 0, transform: "translate(-50%,-56%) scale(1.06) rotate(-6deg)" },
    ], { duration: dur, delay: Math.round(dur * 0.1), fill: "both" });
    later(function () { stamp.remove(); }, dur + 40);

    const sparks = 14;
    for (let i = 0; i < sparks; i++) {
      const dot = document.createElement("div");
      dot.className = "fxemberdot";
      dot.style.background = i % 3 ? "rgb(" + tint + ")" : "#ffe9c2";
      dot.style.boxShadow = "0 0 6px rgba(" + tint + ", .9)";
      dot.style.left = c.x + "px"; dot.style.top = c.y + "px";
      l.appendChild(dot);
      const ang = (i / sparks) * Math.PI * 2 + (i % 2 ? 0.2 : -0.15);
      const dist = Math.min(r.width, r.height) * (0.45 + (i % 4) * 0.12);
      const dx = Math.cos(ang) * dist, dy = Math.sin(ang) * dist;
      play(dot, [
        { opacity: 0, transform: "translate(0,0) scale(.6)" },
        { opacity: 1, transform: "translate(" + (dx * 0.35) + "px," + (dy * 0.35) + "px) scale(1.3)", offset: 0.25, easing: "ease-out" },
        { opacity: 0, transform: "translate(" + dx + "px," + (dy + 18) + "px) scale(.4)" },
      ], { duration: Math.round(dur * 0.6), delay: Math.round(dur * 0.32) + (i % 5) * 18, easing: "ease-out", fill: "both" });
      later(function () { dot.remove(); }, dur + 140);
    }
  }

  function runScore(s, dur) {
    const cry = anchorEl({ anchor: "crystal-" + s.player });
    const to = anchorRect({ anchor: "crystal-" + s.player });
    if (!to) return;
    const from = anchorRect(s.from) || anchorRect({ anchor: "table" });
    const b = centerOf(to);
    const a = from ? centerOf(from) : { x: b.x, y: b.y - 120 };
    const span = cry ? cry.querySelector("span") : null;
    const land = function () {
      Anim.landScore(s.player, s.n || 1);
      if (!span) return;
      const v = parseInt(span.textContent, 10);
      if (isNaN(v)) return;
      span.textContent = String(v + (s.n || 1));
      const arcs = document.querySelectorAll("[data-arc^='" + s.player + "-']");
      for (let i = 0; i < arcs.length; i++) {
        if (parseInt(arcs[i].getAttribute("data-arc").split("-")[1], 10) < v + (s.n || 1)) arcs[i].style.stroke = arcs[i].getAttribute("data-on");
      }
    };

    const fly = Math.round(dur * 0.72);
    const l = Anim.layer();
    if (!Anim.flat()) {
      const trail = document.createElement("div");
      trail.className = "fxtrail";
      const dxT = b.x - a.x, dyT = b.y - a.y;
      const len = Math.sqrt(dxT * dxT + dyT * dyT);
      trail.style.left = a.x + "px";
      trail.style.top = a.y + "px";
      trail.style.width = len + "px";
      trail.style.transform = "rotate(" + (Math.atan2(dyT, dxT) * 180 / Math.PI) + "deg)";
      l.appendChild(trail);
      play(trail, [{ opacity: 0 }, { opacity: .7, offset: 0.4 }, { opacity: 0 }], { duration: fly, easing: "linear", fill: "both" });
      later(function () { trail.remove(); }, fly + 40);

      const gem = document.createElement("div");
      gem.className = "fxgem";
      gem.style.left = (b.x - 9) + "px";
      gem.style.top = (b.y - 11) + "px";
      l.appendChild(gem);
      const dx = a.x - b.x, dy = a.y - b.y;
      play(gem, [
        { opacity: 0, transform: "translate(" + dx + "px," + dy + "px) scale(.6)", easing: EASE.arc },
        { opacity: 1, transform: "translate(" + dx + "px," + (dy - 6) + "px) scale(1.2)", offset: 0.2, easing: EASE.apex },
        { opacity: 1, transform: "translate(0,0) scale(.9)", offset: 0.96, easing: EASE.fall },
        { opacity: 0, transform: "translate(0,0) scale(.4)" },
      ], { duration: fly, fill: "both" });
      later(function () { gem.remove(); }, fly + 40);
      if (s.from) tickPlate(anchorEl(s.from), 0, "fxtick-good");
    }

    const gen = Anim._gen;
    later(function () {
      if (Anim._gen !== gen) return;
      land();
      if (!cry) return;
      play(cry, [
        { filter: "brightness(1)", borderColor: "" },
        { filter: "brightness(1.8)", offset: 0.25 },
        { filter: "brightness(1)" },
      ], { duration: 320, easing: "ease-out" });
      const glow = document.createElement("div");
      glow.className = "fxhexglow";
      glow.style.left = (b.x - 26) + "px";
      glow.style.top = (b.y - 27) + "px";
      l.appendChild(glow);
      play(glow, [
        { opacity: 0, transform: "scale(.8)" }, { opacity: 1, transform: "scale(1.1)", offset: 0.25 },
        { opacity: 0, transform: "scale(1.7)" },
      ], { duration: 360, easing: "ease-out", fill: "both" });
      later(function () { glow.remove(); }, 400);
      if (span) {
        play(span, [
          { transform: "translateY(14px)", opacity: 0 },
          { transform: "translateY(0)", opacity: 1 },
        ], { duration: 220, easing: EASE.arc });
      }
      const pid = cry.closest ? cry.closest(".pid") : null;
      if (pid) play(pid, [
        { transform: "translateY(0)" }, { transform: "translateY(3px)", offset: 0.3 }, { transform: "translateY(0)" },
      ], { duration: 240, easing: EASE.settle });
    }, Math.round(fly * 0.96));
  }

  function runBand(s, dur) {
    const l = Anim.layer();
    const b = document.createElement("div");
    b.className = "fxband" + (s.cls ? " " + s.cls : "");
    const t = document.createElement("span");
    setText(t, s.text);
    b.appendChild(t);
    l.appendChild(b);
    play(b, [
      { opacity: 0, clipPath: "inset(0 50% 0 50%)" },
      { opacity: 1, clipPath: "inset(0 0 0 0)", offset: 0.18 },
      { opacity: 1, clipPath: "inset(0 0 0 0)", offset: 0.78 },
      { opacity: 0, clipPath: "inset(0 50% 0 50%)" },
    ], { duration: dur, easing: EASE.arc, fill: "both" });
    play(t, [
      { opacity: 0, letterSpacing: "16px" },
      { opacity: 1, letterSpacing: "6px", offset: 0.22 },
      { opacity: 1, letterSpacing: "6px", offset: 0.8 },
      { opacity: 0, letterSpacing: "6px" },
    ], { duration: dur, easing: EASE.arc, fill: "both" });
    later(function () { b.remove(); }, dur + 40);
  }

  function runReady(s, dur) {
    const n = s.iids.length;
    if (!n) return;
    const stag = Math.min(60, Math.round((dur - 220) / Math.max(1, n)));
    for (let i = 0; i < n; i++) {
      const e = document.querySelector("[data-iid='" + s.iids[i] + "']");
      if (!e) continue;
      const rune = e.classList.contains("rune");
      play(e, [
        { transform: rune ? "rotate(8deg)" : "none", opacity: rune ? .5 : .6, filter: "grayscale(.6)" },
        { transform: "none", opacity: 1, filter: "none" },
      ], { duration: 220, delay: i * stag, easing: EASE.arc, fill: "backwards" });
    }
  }

  function runExhaust(s, dur) {
    const n = s.iids.length;
    if (!n) return;
    const stag = 60;
    for (let i = 0; i < n; i++) {
      const e = document.querySelector("[data-iid='" + s.iids[i] + "']") ||
        document.querySelector("[data-fxghost='" + s.iids[i] + "']");
      if (!e) continue;
      play(e, [
        { transform: "rotate(0deg)", opacity: 1, filter: "none" },
        { transform: "rotate(8deg)", opacity: .5, filter: "none" },
      ], { duration: 200, delay: i * stag, easing: EASE.arc, fill: "backwards" });
    }
    const group = document.querySelector("[data-iid='" + s.iids[0] + "']");
    const host = group && group.closest ? group.closest(".runegroup") : null;
    if (host) play(host, [
      { boxShadow: "0 0 0 rgba(240,196,106,0)" }, { boxShadow: "0 0 18px rgba(240,196,106,.6)", offset: 0.4 },
      { boxShadow: "0 0 0 rgba(240,196,106,0)" },
    ], { duration: dur, easing: "ease" });
  }

  function runStamp(s, dur) {
    const host = document.querySelector("[data-iid='" + s.iid + "']");
    const badge = host ? host.querySelector(s.sel) : null;
    if (!badge) {
      if (s.fallbackText) mkBanner(s.fallbackText, false, dur, s.cls);
      return;
    }
    if (Anim.flat()) return;
    play(badge, [
      { opacity: 0, transform: "scale(2.2) rotate(-20deg)", easing: EASE.fall },
      { opacity: 1, transform: "scale(1) rotate(0deg)", offset: 0.55 },
      { transform: "scale(1.1) rotate(0deg)", offset: 0.72 },
      { opacity: 1, transform: "scale(1) rotate(0deg)" },
    ], { duration: dur, fill: "both" });
    if (s.shake) play(host, [
      { transform: "translateX(0)" }, { transform: "translateX(-3px)", offset: 0.58 },
      { transform: "translateX(3px)", offset: 0.66 }, { transform: "translateX(0)" },
    ], { duration: dur, easing: "linear" });
  }

  function runBuffRing(s, dur) {
    const host = document.querySelector("[data-iid='" + s.iid + "']");
    const r = anchorRect({ iid: s.iid });
    if (!host || !r) return;
    const badge = host.querySelector(".badge.buff");
    if (badge) play(badge, [
      { opacity: 0, transform: "scale(0) translateY(10px)" },
      { opacity: 1, transform: "scale(1.3) translateY(0)", offset: 0.5 },
      { opacity: 1, transform: "scale(1) translateY(0)" },
    ], { duration: Math.round(dur * 0.6), easing: EASE.arc, fill: "both" });
    const ring = fxBox("fxring", r, 4);
    ring.style.borderColor = "#7bd88f";
    play(ring, [
      { opacity: 0, transform: "scale(.6)" }, { opacity: .9, transform: "scale(1)", offset: 0.3 }, { opacity: 0, transform: "scale(2)" },
    ], { duration: dur, easing: "ease-out", fill: "both" });
    later(function () { ring.remove(); }, dur + 40);
    const mv = host.querySelector(".mv");
    if (mv) play(mv, [
      { transform: "scale(1)" }, { transform: "scale(1.35)", background: "linear-gradient(180deg, #c9f0d2, #46d183)", offset: 0.3 },
      { transform: "scale(1)" },
    ], { duration: Math.round(dur * 0.7), easing: EASE.fall });
  }

  function runMightPop(s, dur) {
    const host = document.querySelector("[data-iid='" + s.iid + "']");
    const mv = host ? host.querySelector(".mv") : null;
    if (!mv) return;
    play(mv, [{ transform: "scale(1)" }, { transform: "scale(1.35)", offset: 0.35 }, { transform: "scale(1)" }], { duration: dur, easing: EASE.fall });
    if (host) play(host, [
      { borderColor: "#f0c46a", boxShadow: "0 0 18px rgba(240,196,106,.45)" },
      { borderColor: "", boxShadow: "" },
    ], { duration: dur, easing: "ease-out" });
  }

  function runRibbon(s, dur) {
    const rib = document.getElementById("phaseribbon");
    if (!rib) return;
    play(rib, [
      { boxShadow: "0 0 0 rgba(240,196,106,0)", borderColor: "" },
      { boxShadow: "0 0 16px rgba(240,196,106,.5)", borderColor: "#f0c46a", offset: 0.3 },
      { boxShadow: "0 0 0 rgba(240,196,106,0)", borderColor: "" },
    ], { duration: dur, easing: "ease" });
  }

  function runStep(s, dur, k) {
    if (s.placeholder) {
      if (s.slotHold) collapsePlaceholder(Anim, s.placeholder, dur, s.slotHold);
      else dropPlaceholder(Anim, s.placeholder);
      s.placeholder = null;
    }
    if (s.kind === "group") {
      for (const c of s.steps) {
        const d = Math.max(80, Math.round((c.dur || s.dur) * k));
        const del = Math.round((c.delay || 0) * k);
        if (!del) { runStep(c, d, k); continue; }
        const gen = Anim._gen;
        later(function () {
          if (Anim._gen !== gen) return;
          try { runStep(c, d, k); } catch (e) { logFx(e); }
        }, del);
      }
      return;
    }
    if (s.kind === "banner") { mkBanner(s.text, s.big, dur, s.cls); return; }
    if (s.kind === "cine") return AX.runCine(s, dur);
    if (s.kind === "arc") { s.hold ? runHoldArc(s, dur) : runArc(s, dur); return; }
    if (s.kind === "spawn") { runSpawn(s, dur); return; }
    if (s.kind === "morph") { runMorph(s, dur); return; }
    if (s.kind === "shuffle") { runShuffle(s, dur); return; }
    if (s.kind === "revealfan") { runRevealFan(s, dur); return; }
    if (s.kind === "handflip") { runHandFlip(s, dur); return; }
    if (s.kind === "chain") { runChain(s, dur); return; }
    if (s.kind === "resolve") { runResolve(s, dur); return; }
    if (s.kind === "retire") { runRetire(s, dur); return; }
    if (s.kind === "flourish") { runFlourish(s, dur); return; }
    if (s.kind === "detonate") { runDetonate(s, dur); return; }
    if (s.kind === "score") { runScore(s, dur); return; }
    if (s.kind === "claim") { runClaim(s, dur); return; }
    if (s.kind === "band") { runBand(s, dur); return; }
    if (s.kind === "ready") { runReady(s, dur); return; }
    if (s.kind === "exhaust") { runExhaust(s, dur); return; }
    if (s.kind === "stamp") { runStamp(s, dur); return; }
    if (s.kind === "buffring") { runBuffRing(s, dur); return; }
    if (s.kind === "mightpop") { runMightPop(s, dur); return; }
    if (s.kind === "ribbon") { runRibbon(s, dur); return; }
    if (s.kind === "pop") {
      const r = anchorRect(s.at);
      if (!r) {
        if (s.fallbackText) mkBanner(s.fallbackText, false, dur, s.cls);
        return;
      }
      const l = Anim.layer();
      const p = document.createElement("div");
      p.className = "fxpop " + (s.cls || "");
      setText(p, s.text);
      const c = centerOf(r);
      p.style.left = c.x + "px";
      p.style.top = (r.top + 4) + "px";
      p.style.animationDuration = wall(dur) + "ms";
      l.appendChild(p);
      later(function () { p.remove(); }, dur + 60);
      return;
    }
  }

  Object.assign(AX, { BLAST_AT: BLAST_AT, BLAST_SETTLE: BLAST_SETTLE, fxBox: fxBox, runStep: runStep });
})();
